module.exports = __webpack_public_path__ + "img/haihengcode.ad786168.png";